import { every, go } from 'fxjs/es';
import { getDesigns, getRealFcanvass } from '../../../../Maker/F/getSth.js';

export const isAllFacesDesignPass = () => {
  return go(
    getRealFcanvass(),
    every((fcanvas) => getDesigns(fcanvas).length),
  );
};
